/* PDP */

/* Bottles quantity */
customCheckCaseBuyDesktopStickyCTA();
stickyVariantChangeInit();
var bottleQuantityWrapper = document.querySelector(".bottlesQuantityWrapper");
if(bottleQuantityWrapper != 0) {
  var bottleQuantityItems = document.querySelectorAll(".bottlesQuantityItem");
  if(bottleQuantityItems.length > 0) {
    for(let i=0; i<bottleQuantityItems.length; i++) {
      let bottleQuantityItem = bottleQuantityItems[i];
      bottleQuantityItem.addEventListener("click", function() {
        let allItems = document.querySelectorAll(".bottlesQuantityItem");
        let maxQty = 99999;
        for(let j=0; j<allItems.length; j++) {
          allItems[j].classList.remove("is-selected");
        }
        let qty = Number(this.getAttribute("data-quantity"));
        let wrapper = this.closest(".product-info__block-list");
        let qtySelecter = wrapper.querySelector(".quantity-selector__input");
        if(qtySelecter.getAttribute("max") != null) {
          maxQty = Number(qtySelecter.getAttribute("max"));
        }
        if(qty > maxQty) {
          qtySelecter.value = maxQty;
        } else {
          qtySelecter.value = qty;
        }
        // Create a new 'change' event
        var event = new Event('change');
        // Dispatch it.
        qtySelecter.dispatchEvent(event);
        
        let allSelectItems = document.querySelectorAll(".bottlesQuantityItem[data-quantity='"+qty+"']");
        for(let j=0; j<allSelectItems.length; j++) {
          allSelectItems[j].classList.add("is-selected");
        }
      });
    }
  }
}
function stickyVariantChangeInit() {
  let stickyVariantElems = document.querySelectorAll(".productVariantPicker .input__list input");
  if(stickyVariantElems.length > 0) {
    for(let i=0; i<stickyVariantElems.length; i++) {
      let stickyVariantElem = stickyVariantElems[i];
      stickyVariantElem.removeEventListener("change", stickyVariantChange);
      stickyVariantElem.addEventListener("change", stickyVariantChange);
    }
  }
}

function updatePriceOnbtn(qty) {
  let btnPrices = document.querySelectorAll(".btnPrice");
  if(btnPrices.length > 0) {
    for(let i=0; i<btnPrices.length; i++) {
      let btnPrice = btnPrices[i];
      let btnPriceBtn = btnPrice.closest(".button");
      if(btnPriceBtn != null) {
        let pdPrice = Number(btnPriceBtn.getAttribute("data-price"));
        let newPdPrice = pdPrice*qty;
        // if(qty >= 6 && qty < 12) {
        //   newPdPrice = (newPdPrice*0.95).toFixed(0);
        // } else if(qty >= 12) {
        //   newPdPrice = (newPdPrice*0.9).toFixed(0);
        // }
        let moneyFormat = btnPriceBtn.getAttribute("data-format");
        btnPrice.innerHTML = Shopify1.formatMoney(newPdPrice, moneyFormat);
      }
    }
  }
}

function stickyVariantChange() {
  let thisValue = this.value;
  let realVariantElem = document.querySelector(`.product-info .variant-picker__option input[data-value="${thisValue}"]+label`);
  if(realVariantElem != null) {
    realVariantElem.click();
  }
}

function customCheckCaseBuyDesktopStickyCTA() {
  if(document.querySelectorAll(".desktopStickyCTAWrapper").length) {
    var checkFirstChange = true;
    let realQtySelector = document.querySelector(".product-info .product-info__block-list .quantity-selector__input");
    let stickyQtySelector = document.querySelector(".desktopStickyCTAWrapper .quantity-selector__input");
    realQtySelector.addEventListener("change", function(){
      let qty = Number(this.value);
      updatePriceOnbtn(qty);
      if(checkFirstChange) {
        stickyQtySelector.value = qty;
      } else {
        checkFirstChange = true;
      }
    });
    stickyQtySelector.addEventListener("change", function(){
      let qty = Number(this.value);
      updatePriceOnbtn(qty);
      if(checkFirstChange) {
        realQtySelector.value = qty;
      } else {
        checkFirstChange = true;
      }
    });
  }
}

//Open Critic Reviews on mobile
var criticReviews = document.querySelector("#product-extra-information .criticReview");
if(criticReviews != null) {
  let accordion = criticReviews.closest(".accordion__disclosure");
  if(accordion != null) {
    if(window.innerWidth <= 768) {
      accordion.open = false;
      accordion.setAttribute("aria-expanded", "false");
    }
  }
}

/* Homepage */
var toggleContents = document.querySelectorAll(".toggleContent");
if(toggleContents.length > 0) {
  for(let i=0; i<toggleContents.length; i++) {
    let toggleContent = toggleContents[i];
    toggleContent.addEventListener("click", function(){
      let thisParent = this.closest(".toggleContentWrapper");
      let thisLongContent = thisParent.querySelector(".longDes");
      let thisShortContent = thisParent.querySelector(".shortDes");
      if(this.innerHTML == "View more") {
        this.innerHTML = "View less";
        thisLongContent.style.display = "block";
        thisShortContent.style.display = "none";
      } else {
        this.innerHTML = "View more";
        thisLongContent.style.display = "none";
        thisShortContent.style.display = "block";
      }
    });
  }
}


var Shopify1 = Shopify1 || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify1.money_format = "${{amount}}";
Shopify1.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};